import { useQuery } from "@tanstack/react-query";
import { getSuppliersForSelect } from "../../api/apiSuppliers";
import i18next from "i18next";

const useGetSuppliersForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["suppliers-for-select", i18next.language],
        queryFn: getSuppliersForSelect,
    });

    return {
        suppliers: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetSuppliersForSelect;
